var title = process.env.VUE_APP_TITLE;
var platformEnv = process.env.VUE_APP_PLATFORM;
import logoHider from '@/assets/logohider.png';
import logoDemi from '@/assets/logo-demi.png';
import logoQyzy from '@/assets/logo-qyzy.png';
import logoQyd from '@/assets/logo-qyd.png';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: title,
      logoHider: logoHider,
      platformEnv: platformEnv
    };
  },
  computed: {
    logoExpand: function logoExpand() {
      if (platformEnv === 'demi') {
        return logoDemi;
      }
      if (platformEnv === 'qyzy') {
        return logoQyzy;
      }
      return logoQyd;
    }
  }
};